define('modules/start/products/sms/index',['require','exports','module','../email/index','./view','./logobutton/view','./activity/view','./status/view','./info/view'],function (require, exports, module) {
    "use strict";

    var ProductEmail = require("../email/index");

    module.exports = {
        View: require("./view"),
        detailsModel: ProductEmail.detailsModel,
        LogoButtonView: require("./logobutton/view"),
        ActivityView: require("./activity/view"),
        StatusView: require("./status/view"),
        InfoView: require("./info/view")
    };
});

